import { BASE_TIERS } from '@/models/ordway';
import Toast from '@/components/display/toast.vue';
import { ProductsApi } from '@/api';

const productApi = new ProductsApi();
const isOnBaseProductTier = (productTier: string) => BASE_TIERS.includes(productTier);

export const canAddUsers = (
	nUsers: number,
	legacySubscriptionItem?: { plan: string; trialPlan: string },
) => {
	let tier: string = '';
	if (legacySubscriptionItem) {
		if (legacySubscriptionItem.trialPlan) {
			tier = legacySubscriptionItem.trialPlan;
		} else if (legacySubscriptionItem.plan) {
			tier = legacySubscriptionItem.plan;
		}
	}
	if (tier !== '' && isOnBaseProductTier(tier)) {
		return nUsers < 3;
	}
	return true;
};

export const getProductAllowedUserIds = async (productId: string | number) => {
	productId = parseInt(productId.toString(), 10);
	try {
		const { data } = await productApi.getProductAllowedUsers(productId, {});
		return data.data || null;
	} catch (e) {
		new Toast().makeToast(`Failed to load product allowed users: ${e}`, 'Error', 'danger');
		return null;
	}
};

export const getProductAllowedUserCount = async (
	productId: string | number,
): Promise<number | null> => {
	productId = parseInt(productId.toString(), 10);
	try {
		const { data } = await productApi.getProductNumUsersAllowed(productId);
		return data.data?.numUsersAllowed ?? null;
	} catch (e) {
		new Toast().makeToast(`Failed to load product allowed user count: ${e}`, 'Error', 'danger');
		return 0;
	}
};
